(function () {
  function text(value) {
    return typeof value === 'string' ? value : '';
  }

  function createMessage(type, content) {
    var message = document.createElement('div');
    message.className = 'ai-message ai-message--' + type;
    message.textContent = content;
    return message;
  }

  function createProducts(products) {
    var list = document.createElement('div');
    list.className = 'ai-products';
    products.slice(0, 3).forEach(function (product) {
      var link = document.createElement('a');
      link.className = 'ai-product';
      link.href = text(product.url) || '#';

      if (product.image && product.image.url) {
        var image = document.createElement('img');
        image.src = product.image.url;
        image.alt = text(product.image.altText) || text(product.title);
        image.loading = 'lazy';
        link.appendChild(image);
      } else {
        var placeholder = document.createElement('span');
        placeholder.setAttribute('aria-hidden', 'true');
        link.appendChild(placeholder);
      }

      var copy = document.createElement('div');
      var title = document.createElement('strong');
      title.textContent = text(product.title);
      copy.appendChild(title);
      if (product.price) {
        var price = document.createElement('span');
        price.textContent = product.price;
        copy.appendChild(price);
      }
      link.appendChild(copy);
      list.appendChild(link);
    });
    return list;
  }

  function init(root) {
    var launcher = root.querySelector('.ai-advisor__launcher');
    var panel = root.querySelector('.ai-advisor__panel');
    var close = root.querySelector('.ai-advisor__close');
    var form = root.querySelector('.ai-advisor__form');
    var input = form && form.querySelector('textarea');
    var messages = root.querySelector('.ai-advisor__messages');
    var endpoint = root.dataset.endpoint;
    var history = [];
    var sending = false;

    function openPanel() {
      panel.hidden = false;
      launcher.setAttribute('aria-expanded', 'true');
      document.body.classList.add('ai-panel-open');
      window.setTimeout(function () { input && input.focus(); }, 50);
    }

    function closePanel() {
      panel.hidden = true;
      launcher.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('ai-panel-open');
      launcher.focus();
    }

    function scrollToBottom() {
      messages.scrollTop = messages.scrollHeight;
    }

    async function sendMessage(value) {
      var message = text(value).trim();
      if (!message || sending) return;
      if (!endpoint || !/^https?:\/\//i.test(endpoint)) {
        messages.appendChild(createMessage('error', 'Consilierul AI nu este încă activat. Completează adresa serviciului AI în setările temei.'));
        scrollToBottom();
        return;
      }

      sending = true;
      messages.appendChild(createMessage('user', message));
      var loading = createMessage('loading', 'Consilierul analizează întrebarea…');
      messages.appendChild(loading);
      scrollToBottom();
      input.value = '';

      try {
        var response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: message,
            history: history.slice(-8),
            page: {
              type: root.dataset.pageType || '',
              productHandle: root.dataset.productHandle || '',
              url: window.location.href
            }
          })
        });
        var data = await response.json().catch(function () { return {}; });
        if (!response.ok) throw new Error(text(data.error) || 'Serviciul nu a răspuns corect.');

        loading.remove();
        var answer = text(data.answer) || 'Nu am putut formula un răspuns. Încearcă o întrebare mai specifică.';
        var assistant = createMessage('assistant', answer);
        if (Array.isArray(data.products) && data.products.length) assistant.appendChild(createProducts(data.products));
        messages.appendChild(assistant);
        history.push({ role: 'user', content: message }, { role: 'assistant', content: answer });
      } catch (error) {
        loading.remove();
        messages.appendChild(createMessage('error', 'Nu m-am putut conecta acum. ' + (error && error.message ? error.message : 'Încearcă din nou.')));
      } finally {
        sending = false;
        scrollToBottom();
      }
    }

    launcher.addEventListener('click', function () { panel.hidden ? openPanel() : closePanel(); });
    close.addEventListener('click', closePanel);
    form.addEventListener('submit', function (event) { event.preventDefault(); sendMessage(input.value); });
    root.querySelectorAll('[data-ai-suggestion]').forEach(function (button) {
      button.addEventListener('click', function () { openPanel(); sendMessage(button.dataset.aiSuggestion); });
    });
    document.querySelectorAll('[data-open-ai-advisor]').forEach(function (button) { button.addEventListener('click', openPanel); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !panel.hidden) closePanel(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ai-advisor]').forEach(init);
  });
})();
